if (!customElements.get('rone-tier-select')) {
  customElements.define(
    'rone-tier-select',
    class RoneTierSelect extends HTMLElement {
      connectedCallback() {
        this.msrp = parseFloat(this.dataset.msrp || '0');
        this.baseHref = this.dataset.ctaBaseHref || '';
        this.offerName = this.dataset.offerName || '';

        this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
        this.ctaLink = this.querySelector('[data-cta-link]');
        this.ctaDays = this.querySelector('[data-cta-days]');
        this.ctaPct = this.querySelector('[data-cta-pct]');
        this.ctaMsrp = this.querySelector('[data-cta-msrp]');
        this.ctaTotal = this.querySelector('[data-cta-total]');
        this.clubRefill = this.querySelector('[data-club-refill]');
        this.giftItems = Array.from(this.querySelectorAll('[data-gift-item]'));
        this.giftCount = this.querySelector('[data-gift-unlocked-count]');

        this.tiers.forEach((tier) => {
          tier.addEventListener('click', () => this.select(tier));
        });

        const active = this.tiers.find((t) => t.classList.contains('rone-tier--on')) || this.tiers[0];
        if (active) this.select(active);
      }

      select(tier) {
        this.tiers.forEach((t) => {
          const on = t === tier;
          t.classList.toggle('rone-tier--on', on);
          t.setAttribute('aria-checked', on);
        });

        const qty = parseInt(tier.dataset.qty, 10);
        const price = parseFloat(tier.dataset.price);
        const renewalPrice = parseFloat(tier.dataset.renewalPrice);
        const days = (tier.dataset.days || '').trim();
        const total = price * qty;
        const msrpTotal = this.msrp * qty;
        const pct = msrpTotal > 0 ? Math.round(((msrpTotal - total) / msrpTotal) * 100) : 0;

        this.tiers.forEach((t) => {
          const tQty = parseInt(t.dataset.qty, 10);
          const tPrice = parseFloat(t.dataset.price);
          const saveEl = t.querySelector('[data-tier-save]');
          if (saveEl) saveEl.textContent = 'Save $' + Math.round((this.msrp - tPrice) * tQty);
        });

        if (this.ctaDays) this.ctaDays.textContent = days;
        if (this.ctaPct) this.ctaPct.textContent = pct;
        if (this.ctaMsrp) this.ctaMsrp.textContent = this.formatMoney(msrpTotal);
        if (this.ctaTotal) this.ctaTotal.textContent = this.formatMoney(total);
        if (this.clubRefill) {
          // The club-benefits line describes ongoing refills, so it needs the
          // renewal (post-introductory-cycle) price, not the first-order
          // price used for the CTA total above — subscriptions can bill a
          // different rate once the intro cycle ends.
          this.clubRefill.textContent = qty + ' bag refill ships every ' + days + ' days at ' + this.formatMoney(renewalPrice) + '/ea';
        }
        this.updateGifts(qty);
        if (this.ctaLink) {
          this.ctaLink.href = this.baseHref
            + '?step=flavors&quantity=' + qty
            + '&frequency=' + days;
        }

        this.dispatchEvent(
          new CustomEvent('rone:tier-select', {
            bubbles: true,
            composed: true,
            detail: { qty, price, total, msrpTotal, pct, days },
          })
        );
      }

      formatMoney(amount) {
        return '$' + amount.toFixed(2);
      }

      updateGifts(qty) {
        if (!this.giftItems.length) return;
        let unlocked = 0;
        this.giftItems.forEach((item) => {
          const reached = qty >= parseInt(item.dataset.threshold, 10);
          item.classList.toggle('rone-gift--unlocked', reached);
          if (reached) unlocked++;
        });
        if (this.giftCount) this.giftCount.textContent = unlocked;
      }
    }
  );
}
